import { InstallLatestCommand } from './commands/install-latest.command';
import { ShellCommand } from './commands/shell.command';
import { WriteFileCommand } from './commands/writeFile.command';
import { Procedure } from './procedure.interface';
import { RESET_COMMANDS } from './reset';

export const INSTALL_ORTHO: Procedure = {
  name: 'Ortho',
  resetCommands: RESET_COMMANDS,
  commands: [
    new InstallLatestCommand('ORTHO', true), // UPDATE
    new InstallLatestCommand('ORTHO'),
    new WriteFileCommand('/sdcard/config.txt', 'open_guide:0\n------\nhome_pkg:fr.eyesoft.app\n------\n'),
    new ShellCommand('setprop persist.pxr.force.home fr.eyesoft.app,com.unity3d.player.UnityPlayerNativeActivityPico'),
  ],
  validationCommands: [], // TODO: Check install and read config.txt
};

export const INSTALL_ORTHO_HOME: Procedure = {
  name: 'Ortho',
  resetCommands: [...INSTALL_ORTHO.resetCommands],
  commands: [...INSTALL_ORTHO.commands, new WriteFileCommand('/storage/self/primary/Android/data/fr.eyesoft.config.patient', '')],
  validationCommands: [], // TODO: Check install and read config.txt
};
